/*
 * Curbstruck — PDP (Lote 3 da story 1.8).
 * Unico trabalho: o atalho "Size guide" do cabecalho do seletor de tamanho abre e
 * rola ate o acordeao que ja existe na coluna ("Size guide & fit", bloco sizeguide
 * de templates/product*.json -> <details id="Details-sizeguide-{section}">).
 * Delegacao no document porque o seletor e re-renderizado a cada troca de variante.
 */
document.addEventListener('click', function (event) {
  var trigger = event.target.closest('[data-cbs-sizeguide]');
  if (!trigger) return;
  var panel = document.querySelector('details[id^="Details-sizeguide-"]');
  if (!panel) return;
  panel.open = true;
  panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
  var summary = panel.querySelector('summary');
  if (summary) summary.focus({ preventScroll: true });
});
